import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'meals',
    lazy: async () => ({ Component: (await import('./MealsPage')).MealsPage }),
  },
];
